import React, { JSX } from 'react';
import Icon from '@ant-design/icons';
import classNames from 'classnames';

import { Button, ButtonPropsType, ButtonType } from '../../Controls/Button';
import AddCommentIconSvg from './addComment.svg';
import CommentIconSvg from './comment.svg';
import cn from './styles.module.scss';

export interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export interface CommentsIconButtonPropsType extends IconButtonPropsType {
  commentsCount: number;
}

export const AddCommentIcon = (props: any): JSX.Element => <Icon component={AddCommentIconSvg} {...props} />;
export const CommentIcon = (props: any): JSX.Element => <Icon component={CommentIconSvg} {...props} />;

export const CommentIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, CommentsIconButtonPropsType>(
  ({ commentsCount = 0, size = 'medium', iconSize = 24, type = ButtonType.Tertiary, ...props }, ref): JSX.Element => {
    if (commentsCount === 0) {
      return (
        <Button
          ref={ref}
          type={type}
          className={classNames(cn.button, cn.commentButton, cn.commentButtonContainer, props?.className)}
          icon={<AddCommentIconSvg width={iconSize} height={iconSize} fill="currentColor" />}
          size={size}
          data-testid="CommentIconButton"
          {...props}
        />
      );
    }

    return (
      <Button
        ref={ref}
        type={type}
        icon={<CommentIconSvg width={iconSize} height={iconSize} fill="currentColor" />}
        size={size}
        className={classNames(cn.button, cn.commentButton, cn.commentButtonContainer, props)}
        data-testid="CommentIconButton"
        {...props}
      >
        <div className={cn.commentCountText}>
          {commentsCount}
        </div>
      </Button>
    );
  },
);
CommentIconButton.displayName = 'CommentIconButton';
